import {clipboardCheckSvg as Icon__small__clipboardCheckSvg} from '../Icon__small/Icon__small--clipboardCheck.js'

export var clipboardCheck = {
  name: 'clipboardCheck',
  category: 'icon',
  colorable: true,
  svg: Icon__small__clipboardCheckSvg,
};
